import { useHoaDonMuaHangTrongNuocSearchContext } from './useHoaDonMuaHangTrongNuocSearchContext';
import { useHoaDonMuaHangTrongNuocMutation } from './useHoaDonMuaHangTrongNuocMutation';
import { useHoaDonMuaHangTrongNuocImport } from './useHoaDonMuaHangTrongNuocImport';
import { useHoaDonMuaHangTrongNuocTable } from './useHoaDonMuaHangTrongNuocTable';

export const useHoaDonMuaHangTrongNuocPage = () => {
  const { transactionOptions, isExporting, isImportDialogOpen, openImportDialog, closeImportDialog } =
    useHoaDonMuaHangTrongNuocSearchContext();
  const tableState = useHoaDonMuaHangTrongNuocTable();
  const importState = useHoaDonMuaHangTrongNuocImport({
    closeImportDialog,
    refreshData: tableState.crud.refreshData,
    transactionOptions
  });
  const mutationState = useHoaDonMuaHangTrongNuocMutation({ tableState });

  return {
    searchDialog: tableState.searchDialog,
    importDialog: {
      open: isImportDialogOpen,
      isImporting: importState.isImporting,
      openDialog: openImportDialog,
      closeDialog: closeImportDialog,
      onSubmit: importState.handleImportFromExcel
    },
    importErrorDialog: importState.importErrorDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: mutationState.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      onConfirm: mutationState.handleDelete
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    table: tableState.table,
    detailTable: {
      rows: (tableState.crud.detail as MuaHangRecord)?.chi_tiet_hoa_don || []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: mutationState.handleEditClick,
      handleViewClick: tableState.form.handleViewClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
